module.exports = __webpack_public_path__ + "img/puzzle.4c7e5f74.svg";